import axios from 'axios'
import { API_BASE_URL } from '../globalVar'

function authoriseable(payload) {
    return axios.post(API_BASE_URL + '/api/admin/v1/finance/canauthoriseclaimpayment', payload)
}

function authorise(payload) {
    return axios.post(API_BASE_URL + '/api/admin/v1/finance/authoriseclaimpayment', payload)
}

function getAll(payload) {
    return axios.post(API_BASE_URL + '/api/admin/v1/finance/allclaimpayments/search', payload)
}

export const claimPaymentsService = {
    authoriseable,
    authorise,
    getAll
}